import Icon from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { ReactComponent as SettingIcon } from '../assets/setting.svg';
import { MenuButton } from './MenuButton';
import { useCallback } from 'react';
import { eventBus } from 'services/eventBus';

interface SystemSettingProps {
  hidePopover: () => void;
}

export const SystemSetting = (props: SystemSettingProps) => {
  const { hidePopover } = props;
  const { t } = useTranslate();

  const handleClick = useCallback(() => {
    hidePopover();
    eventBus.emit('SHOW_SYSTEM_MODAL', {
      activeKey: 'preference',
    });
  }, [hidePopover]);

  return (
    <MenuButton
      label={t('ViewSystem.system.title.setting')}
      customIcon={<Icon component={SettingIcon} />}
      onClick={handleClick}
    />
  );
};
